export default __webpack_public_path__ + "static/media/luggage.979e4637.png";